module.exports = __webpack_public_path__ + "img/tablist-ico02.90d57eb3.png";